/**
=========================================================
* Vue Soft UI Dashboard PRO - v3.0.0
=========================================================
* Product Page: https://creative-tim.com/product/vue-soft-ui-dashboard-pro
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
Coded by www.creative-tim.com
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import VueTilt from "vue-tilt.js";
import SoftUIDashboard from "./soft-ui-dashboard";

import { createVfm } from 'vue-final-modal';
import 'vue-final-modal/dist/style.css'

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { useToast } from "vue-toastification";
import { createI18n } from 'vue-i18n';
import it from './locales/it';
import en from './locales/en';
import {axiosService} from "@/services/AxiosService";
import Vueform from '@vueform/vueform';
import vueformConfig from './../vueform.config';

import moment from 'moment';
import 'moment/locale/it';
moment.locale('it'); 

const vfm = createVfm()


const i18n = createI18n({
    locale: 'it', // Set the default locale
    fallbackLocale: 'en', // Fallback language if translation is missing
    messages: {
        it,
        en
    },
});

const appInstance = createApp(App);

appInstance.use(Toast, {});
appInstance.use(i18n);
appInstance.use(Vueform, vueformConfig);

appInstance.use(store);
appInstance.use(router);
appInstance.use(VueTilt);
appInstance.use(vfm);
appInstance.use(SoftUIDashboard);

appInstance.config.globalProperties.$moment = moment;

// Quando l'app si carica, controlla se esiste il token di autenticazione
const authToken = localStorage.getItem('authToken');

if (authToken) {
    // Imposta il token nell'istanza Axios del servizio AxiosService
    axiosService.updateToken();  // Chiama direttamente updateToken da axiosService

    // Chiama l'API per ottenere le informazioni dell'utente e salvarle in Vuex
    store.dispatch('fetchUserInfo', authToken)
        .then(() => {
            //router.push('/dashboard');
            store.dispatch('fetchNotifications')
            // set interval to call fetch notifications each 30 seconds
            setInterval(() => {
                store.dispatch('fetchNotifications')
            }, 30000);
            appInstance.mount("#app");
        })
        .catch(() => {
            // Se non riesce a recuperare le informazioni, rimuove il token e reindirizza al login
            localStorage.removeItem('authToken');
            axiosService.updateToken();  // Aggiorna dopo la rimozione del token
            router.push('/sign-in');
        });
} else {
    // Nessun token trovato, reindirizza alla pagina di login
    router.push('/sign-in');
    appInstance.mount("#app");
}

appInstance.config.errorHandler = function (err) {
    if (err.message === 'e.preventDefault is not a function') return;
    let message = err.message;
    if(err?.response?.data?.message) message = err.response.data.message;
    const toast = useToast();
    toast.error(message);
    console.log('ERROR1:', err)
};
